import React, { useState } from 'react';
import '../styles/Contact.css';
import Navbar from './Navbar';
import contactBackground from '../assets/images/contact_us_background.png';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, success: false, message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setToast({ show: false, success: false, message: '' });

    try {
      const response = await fetch('https://playerstat.ai.acufore.in/send_mail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        setToast({ show: true, success: true, message: 'Message sent successfully!' });
        setFormData({ name: '', email: '', message: '' });
      } else {
        setToast({ show: true, success: false, message: 'Failed to send message: ' + result.error });
      }
    } catch (error) {
      setToast({ show: true, success: false, message: 'An error occurred: ' + error.message });
    }
    setLoading(false);
  };

  const Toaster = ({ show, success, message, onClose }) => {
    React.useEffect(() => {
      if (show) {
        const timer = setTimeout(onClose, 3000);
        return () => clearTimeout(timer);
      }
    }, [show, onClose]);
    return show ? (
      <div className={`toaster ${success ? 'toaster-success' : 'toaster-error'}`}>
        {success ? <span className="toaster-icon">&#10003;</span> : <span className="toaster-icon">&#10060;</span>}
        <span>{message}</span>
      </div>
    ) : null;
  };

  return (
    <div className="contact-page">
      <Navbar />
      <div className="contact-background">
        <img 
          src={contactBackground} 
          alt="Contact Background" 
          className="contact-background-image"
        />
        <div className="contact-form-container">
          <h2 className="contact-title">Get in touch with us</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="contact-input"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              className="contact-input"
              required
            />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              className="contact-textarea"
              required
            />
            <button type="submit" className="contact-submit-button" disabled={loading}>
              {loading ? 'Sending...' : 'Send'}
            </button>
          </form>
          <Toaster
            show={toast.show}
            success={toast.success}
            message={toast.message}
            onClose={() => setToast({ ...toast, show: false })}
          />
        </div>
      </div>
    </div>
  );
};

export default Contact; 